import ButtonCinestar from 'components/Buttons/ButtonCinestar/ButtonCinestar'
import Icon from 'components/Icon/Icon'
import { Html5Qrcode } from 'html5-qrcode/'
import { useEffect, useRef, useState } from 'react'
import './CameraQrLoader.scss'

export default function CameraQrLoader({ loadTicket }) {
    const [open, setOpen] = useState(false)

    const html5QrCode = useRef(null)
    useEffect(() => {
        html5QrCode.current = new Html5Qrcode('reader')
    }, [])

    const startCamereQr = () => {
        setOpen(true)

        function onScanSuccess(decodedText, decodedResult) {
            loadTicket({ voucher_number: decodedText })
            html5QrCode.current.stop()
            setOpen(false)
        }

        function onScanFailure() {}

        const config = { fps: 10 }

        // prefer back camera
        html5QrCode.current.start({ facingMode: 'environment' }, config, onScanSuccess, onScanFailure)
    }

    const closeAndStop = () => {
        setOpen(false)
        try {
            html5QrCode.current.stop()
        } catch (error) {
            return
        }
    }
    return (
        <>
            <ButtonCinestar
                onClick={() => {
                    startCamereQr()
                }}
                className={'mt-auto text-nowrap'}
                variant={'primary-v1'}
            >
                <Icon name={'camera'} />
            </ButtonCinestar>

            <div style={{ display: open ? 'flex' : 'none' }} className="qr-camera-loader-popup-bg">
                <div className="qr-loader-element">
                    <Icon name={'cross'} className={'cross-icon'} role={'button'} onClick={closeAndStop} />
                    <div id="reader"></div>

                    <div style={{ position: 'absolute', bottom: 10, right: 10 }}>
                        <ButtonCinestar className={'text-nowrap'} variant={'primary-v1'}>
                            <label htmlFor="imgFile">Nahrát ze souboru</label>
                        </ButtonCinestar>
                        <input
                            id={'imgFile'}
                            className={'d-none'}
                            type="file"
                            accept="image/*"
                            onChange={(e) => {
                                closeAndStop()
                                loadTicket(e.target.files[0])
                            }}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}
